import { PropType } from 'vue'
import { Person } from '@/api/entities/people/types'
import {
  AskAProfileResponse,
  LlmDatadogLoggingDetails,
} from '@/libs/features/llm/types'

export type SectionResult = {
  title: string
  response?: AskAProfileResponse
  loggingDetails?: LlmDatadogLoggingDetails
  error: boolean
}

export const ASK_A_PROFILE_PROPS = {
  patientPerson: {
    type: Object as PropType<Person | null>,
    required: false,
    default: null,
  },
  showDevTools: { type: Boolean, required: false, default: false },
} as const

export enum AskAProfileTool {
  COMMUNICATIONS = 'communications',
  PERSONAL_INFORMATION = 'personal_information',
  SUBTASKS = 'subtasks',
  GOALS_AND_PLAYBOOKS = 'goals_and_playbooks',
  CLAIMS = 'claims',
  CARE_PLAN = 'care_plan',
  SOCIAL_SUMMARY = 'social_summary',
  CLINICAL_SUMMARY = 'clinical_summary',
}
